/* i18n international support based on angular-translate module + text translation utilities */
angular.module('translator', ['pascalprecht.translate', 'config', 'identity'])

angular.module('translator').config(function ($translateProvider) {
	//Configure i18n translation module
	$translateProvider
		.useStaticFilesLoader({
			prefix: '/i18n/',
			suffix: '.json',
		})
		.useLoaderCache(true)
		.useSanitizeValueStrategy('escaped')
	//$translateProvider.determinePreferredLanguage();
})

angular.module('translator').run(function (tgConfig, tgTranslate) {
	//Set current supported languages:
	tgTranslate.setSupportedLanguages(tgConfig.locales)
	tgTranslate.preferredLanguage(tgConfig.preferredLanguage)
	//Pre-loading all languages and resets session language at the end:
	tgConfig.locales.forEach(function (element) {
		tgTranslate.use(element.code).then(function (data) {
			tgTranslate.use(tgConfig.preferredLanguage)
		})
	})
})
